<div id="exceptionDayDialog">
    <div class="popupHeader" mat-dialog-title>
        <span>{{'SLIICER.EDIT_SETTINGS.EXCEPTION_DAYS.ADD_EXCEPTION' | translate}}</span>
    </div>
    <div mat-dialog-content>
        <form>
            <div></div>
            <div>
                <mat-form-field class="full-width">
                    <mat-select
                        placeholder="{{ 'SLIICER.EDIT_SETTINGS.EXCEPTION_DAYS.SELECT_DAY_OF_WEEK_GROUP' | translate }}"
                        required
                        name="dayGroupName"
                        [(ngModel)]="form.dayGroupName"
                        (ngModelChange)="onDayGroupNameChange()"
                    >
                        <mat-option *ngFor="let item of daysGroup; trackBy: trackByIndex" [value]="item.name">{{ item.name }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <div class="custom-error">
                    <mat-form-field>
                        <input
                            #dateInputField="ngModel"
                            matInput
                            [(ngModel)]="form.exceptionDate"
                            (ngModelChange)="onExceptionDateChange()"
                            [debounce]="{ value: 200, initial: true }"
                            name="date"
                            [matDatepickerFilter]="excludeExisting"
                            [matDatepicker]="date"
                            [min]="caseStudyStartDate"
                            [max]="caseStudyEndDate"
                            placeholder="{{'COMMON.DATE_TEXT' | translate}}"
                            required
                        />
                        <mat-datepicker-toggle matSuffix [for]="date"> </mat-datepicker-toggle>
                        <mat-datepicker #date></mat-datepicker>
                    </mat-form-field>
                    <div class="custom-error-message" *ngIf="dateInputField.errors?.matDatepickerParse">
                        {{'COMMON.INVALID_DATE_FORMAT' | translate }}
                    </div>
                    <div class="custom-error-message" *ngIf="dateInputField.errors?.matDatepickerFilter">
                        {{'COMMON.DATE_ALREADY_ASSIGNED' | translate }}
                    </div>
                    <div class="custom-error-message" *ngIf="dateInputField.errors?.matDatepickerMax || dateInputField.errors?.matDatepickerMin">
                        {{'SLIICER.COMMON.DATE_OUTSIDE_OF_STUDY_RANGE' | translate }}
                    </div>
                </div>
            </div>
        </form>
    </div>


    <div mat-dialog-actions>
        <div class="app-flex-filler"></div>
        <div class="auto-margin">
            <button mat-button mat-dialog-close>{{ 'COMMON.CANCEL_BUTTON' | translate }}</button>
        </div>
        <div class="auto-margin">
            <button mat-button (click)="save()" [disabled]="!form.exceptionDate || !validation.isDayGroupNameValid || (!isFormChanged && data.edit) || dateInputField.invalid">
                {{ 'COMMON.SAVE_BUTTON' | translate }}
            </button>
        </div>
    </div>
</div>
